// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"eb17f62b47ea1380","6626":"9dbff2e13711323a"}[chunkId] + ".css";
};